import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail, Facebook, Instagram, Calendar } from 'lucide-react';
import { SITE, SERVICES, LOCATIONS, NAV } from '@/data/site-config';
import { Logo } from './Header';

export function Footer() {
  return (
    <footer className="border-t border-[color:var(--ft-border)] bg-[color:var(--ft-bg-2)] mt-12" role="contentinfo">
      <div className="container-x py-14 grid gap-10 md:grid-cols-12">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3 mb-3">
            <Logo size={60} />
            <div className="leading-tight">
              <div className="font-display text-lg font-semibold">{SITE.name}</div>
              <div className="text-xs text-[color:var(--ft-accent)] uppercase tracking-widest font-semibold">Private Studio</div>
            </div>
          </div>
          <p className="text-sm text-[color:var(--ft-muted)] max-w-sm">Private personal training studio in {SITE.city}, {SITE.stateAbbr}. NASM-certified coach {SITE.owner} — serving {SITE.county}.</p>
          <div className="mt-4 grid gap-2 text-sm">
            <a href={`tel:${SITE.phoneE164}`} className="inline-flex items-center gap-2 text-[color:var(--ft-text)] hover:text-[color:var(--ft-accent)]"><Phone size={14} /> {SITE.phone}</a>
            <a href={`mailto:${SITE.email}`} className="inline-flex items-center gap-2 text-[color:var(--ft-text)] hover:text-[color:var(--ft-accent)] break-all"><Mail size={14} /> {SITE.email}</a>
            <a href="https://maps.google.com/?q=3850+SE+Dixie+Highway+Stuart+FL+34997" target="_blank" rel="noreferrer" className="inline-flex items-start gap-2 text-[color:var(--ft-text)] hover:text-[color:var(--ft-accent)]"><MapPin size={14} className="mt-1" /> <span>{SITE.address.line1}<br />{SITE.address.line2}</span></a>
          </div>
          <div className="mt-4 flex flex-wrap items-center gap-2">
            <a href={SITE.social.facebookOwner} target="_blank" rel="noreferrer" aria-label="Connect with Jarad on Facebook" className="fb-chip" data-testid="footer-fb-jarad"><Facebook size={14} fill="#fff" /> Connect with Jarad</a>
            <a href={SITE.social.facebook} target="_blank" rel="noreferrer" aria-label="FT360 Facebook" className="btn btn-ghost btn-sm hover:text-[#1877F2]" data-testid="footer-facebook"><Facebook size={16} /></a>
            <a href={SITE.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="btn btn-ghost btn-sm" data-testid="footer-instagram"><Instagram size={16} /></a>
            <a href={SITE.booking.url} target="_blank" rel="noreferrer" className="btn btn-primary btn-sm" data-testid="footer-vagaro"><Calendar size={14} /> {SITE.booking.label}</a>
          </div>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-display text-sm font-semibold mb-3 uppercase tracking-wider text-[color:var(--ft-dim)]">Explore</h4>
          <ul className="grid gap-2 text-sm">
            {NAV.map((n) => (<li key={n.href}><Link className="text-[color:var(--ft-muted)] hover:text-[color:var(--ft-text)]" to={n.href}>{n.label}</Link></li>))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-display text-sm font-semibold mb-3 uppercase tracking-wider text-[color:var(--ft-dim)]">Services</h4>
          <ul className="grid gap-2 text-sm">
            {SERVICES.map((s) => (<li key={s.slug}><Link className="text-[color:var(--ft-muted)] hover:text-[color:var(--ft-text)]" to={`/services/${s.slug}`}>{s.title}</Link></li>))}
          </ul>
          <h4 className="font-display text-sm font-semibold mb-3 mt-5 uppercase tracking-wider text-[color:var(--ft-dim)]">Hours</h4>
          <p className="text-sm text-[color:var(--ft-muted)]">{SITE.hoursDetail}</p>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-display text-sm font-semibold mb-3 uppercase tracking-wider text-[color:var(--ft-dim)]">Service area</h4>
          <ul className="grid grid-cols-2 gap-x-3 gap-y-2 text-sm">
            {LOCATIONS.slice(0, 8).map((l) => (<li key={l.slug}><Link className="text-[color:var(--ft-muted)] hover:text-[color:var(--ft-text)]" to={`/locations/${l.slug}`}>{l.name}</Link></li>))}
            <li><Link className="text-[color:var(--ft-accent)] hover:underline" to="/locations">All locations →</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[color:var(--ft-border)]">
        <div className="container-x py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[color:var(--ft-dim)]">
          <p>© {new Date().getFullYear()} {SITE.name}. All rights reserved. NASM-Certified Personal Trainer.</p>
          <div className="flex flex-wrap gap-x-5 gap-y-1 justify-center">
            <Link to="/privacy-policy" className="hover:text-[color:var(--ft-text)]">Privacy</Link>
            <Link to="/terms" className="hover:text-[color:var(--ft-text)]">Terms</Link>
            <Link to="/accessibility" className="hover:text-[color:var(--ft-text)]">Accessibility</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
